import { Component, ViewChild, ElementRef } from '@angular/core';
import { IntegerWidget as _IntegerWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-integer-widget',
  templateUrl: './integer.widget.html',
} )
export class IntegerWidget extends _IntegerWidget {
  private _displayValue: string;
  schema: JSONSchema;
  @ViewChild( 'input' ) element: ElementRef;

  get prefix(): string {
    return ( this.schema.options && this.schema.options.prefix ) || '';
  }

  get suffix(): string {
    return ( this.schema.options && this.schema.options.suffix ) || '';
  }

  get step(): string {
    // `number` accepts decimals; `integer` is whole-number only. Without a step the
    // browser defaults to 1 and rejects typed decimals on number fields.
    return this.schema.type === 'integer' ? '1' : 'any';
  }

  get required() {
    return isWidgetRequired( this );
  }

  ngAfterViewInit() {
    const control = this.control;
    this.formProperty.valueChanges.subscribe(( newValue ) => {
      if ( typeof this._displayValue !== 'undefined' ) {
        // Ignore the model value, use the display value instead
        if ( control.value !== this._displayValue ) {
          control.setValue( this._displayValue, { emitEvent: false } );
        }
      } else {
        if ( control.value !== newValue ) {
          control.setValue( newValue, { emitEvent: false } );
        }
      }
    } );
    this.formProperty.errorsChanges.subscribe(( errors ) => {
      control.setErrors( errors, { emitEvent: true } );
      const messages = ( errors || [] )
        .filter( e => {
          return e.path && e.path.slice( 1 ) === this.formProperty.path;
        } )
        .map( e => e.message );
      this.errorMessages = messages.filter(( m, i ) => messages.indexOf( m ) === i );
    } );
    control.valueChanges.subscribe(( newValue: string ) => {
      this._displayValue = newValue;
      this.formProperty.setValue( newValue, false );
      delete this._displayValue;
      if ( newValue === '' && ( <HTMLInputElement>this.element.nativeElement ).validity.badInput ) {
        // Show a custom error instead
        this.formProperty.extendErrors( [ {
          path: '#' + this.formProperty.path,
          message: 'Invalid number',
        }] );
      }
    } );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/integer.widget.ts